import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

/**
 * Global "Powered by" footer. Vises på alle sider.
 * Henter platform settings fra API og cacher dem.
 */
let cachedSettings = null;

export default function PoweredByFooter() {
  const [settings, setSettings] = useState(cachedSettings);

  useEffect(() => {
    if (cachedSettings) return;
    axios.get(`${API}/platform/settings`)
      .then(r => { cachedSettings = r.data; setSettings(r.data); })
      .catch(() => {});
  }, []);

  if (!settings?.powered_by_enabled) return null;

  return (
    <div className="py-4 text-center" data-testid="powered-by-footer">
      <div className="inline-flex items-center gap-2 text-[11px] text-muted-foreground/40">
        {settings.host_logo_url && (
          <img 
            src={`${API.replace('/api', '')}${settings.host_logo_url}`}
            alt={settings.host_name}
            className="h-4 w-auto opacity-40"
          />
        )}
        <span>
          {settings.platform_name || 'Resovia'} &mdash;{' '}
          {settings.powered_by_text || 'powered by'}{' '}
          <span className="font-semibold">{settings.host_name}</span>
        </span>
      </div>
    </div>
  );
}
